module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNGf95579cb1824609824cd748de7d8361f.f95579cb.png";